import React, {  useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"   
import { ENDPOINT } from "constants/variables"; 
import Box from '@mui/material/Box';    
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingViewsFormDI from "pages/purchaseDelivery/purchaseDeliveryFilterList/SortingTablesPurchaseFormDI";
import PropTypes from 'prop-types';
       
const initialStateFormDI = [{
  "id" : 0, 
  "ownformdi_id":0,
  "preiddoc_sheet" : "",
  "sufiddoc_sheet" : "", 
  "number_dt": "",
  "date_sheet" : null 
}];  

const PurchaseFormDI = ({ openViewFormDI, setOpenViewFormDI,rowEditPurchaseDelivery}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token); 
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesizetickes);
  const [dataFormDI, setDataFormDI] = useState(initialStateFormDI);
  const [isLoadingErrorFormDI, setIsLoadingErrorFormDI] = useState(false);
  const isLoading = useSelector((state) => state.loading.isLoading);  
  const [numTotRegFormDI,setNumTotRegFormDI]= useState(0);
  const [activeOffsetFormDI, setActiveOffsetFormDI]= useState(false);
  const [currencyOffsetFormDI, setCurrencyOffsetFormDI] = useState(0);
  const [rangeOffsetFormDI, setRangeOffsetFormDI] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const handleCloseDataViewFormDI = () => {
    setDataFormDI(initialStateFormDI);
    setIsLoadingErrorFormDI(false);
    dispatch(setLoading(false)); 
    setNumTotRegFormDI(0);
    setActiveOffsetFormDI(false);
    setCurrencyOffsetFormDI(0);
    setRangeOffsetFormDI([{}]); 
    setOpenViewFormDI(false)
	};
   
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegFormDI = async () => { 
      try {
        const getData  = await helpHttp().get2(ENDPOINT,`purchasedelivery/getinformationpurchasedeliveryformdi/`,token,rowEditPurchaseDelivery.id);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }  
          } 
        } else if (isMounted) {
          setNumTotRegFormDI(getData); 
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        dispatch(setLoading(false)); 
      }
    };

    const fetchdataFormDI = async () => {
      try {
        dispatch(setLoading(false));
        const getData = await helpHttp().get7(ENDPOINT,`purchasedelivery/getformdisbypurchaseid`,token,currencyOffsetFormDI,LIMITPAGESIZE,rowEditPurchaseDelivery.id);
        if (getData.err) {
          dispatch(setLoading(false));
          setDataFormDI(initialStateFormDI);
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setDataFormDI(getData);
          dispatch(setLoading(false)); 
        } 
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }; 
    
    if (openViewFormDI){ 
      fetchnumTotRegFormDI(); 
      fetchdataFormDI();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,LIMITPAGESIZE,currencyOffsetFormDI,openViewFormDI,rowEditPurchaseDelivery.id]);
  
  const toggleDrawerSearchFormDI  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataViewFormDI();
    }
  };

  return(
    <>
      {openViewFormDI && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormDI(false)}
            onOpen={toggleDrawerSearchFormDI(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff', width: '1150px'}}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorFormDI?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoading?<CircularProgress color={"primary"}/>:<i className="fas fa-regular fa-clipboard text-warning"></i>} {t('Text_NumberPurchase')+": "+rowEditPurchaseDelivery.purchasenote}
                  </h1>
                  <div>
                    <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataViewFormDI} >{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>  
                {!isLoading ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                        <TableSortingViewsFormDI
                          dataFormDI={dataFormDI} 
                          titleTable={"Text_DIs_AVAILABLE"}
                          numTotRegFormDI={numTotRegFormDI}
                          activeOffsetFormDI={activeOffsetFormDI}
                          rangeOffsetFormDI={rangeOffsetFormDI}
                          currencyOffsetFormDI={currencyOffsetFormDI}
                          setCurrencyOffsetFormDI={setCurrencyOffsetFormDI} 
                        >
                      </TableSortingViewsFormDI>
                      </div>             
                    </div>
                     
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                } 
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

PurchaseFormDI.propTypes = {
  openViewFormDI: PropTypes.bool.isRequired,
  setOpenViewFormDI: PropTypes.func.isRequired 
};

export default PurchaseFormDI;

